module.exports = __webpack_public_path__ + "img/front_page_customers.bee20230.svg";